import { DocumentStatus } from './types';

/**
 * SHER-429 — hide Payé / payment actions when a closed invoice has nothing left
 * for the patient to pay (full exoneration or discount). Draft bills stay editable.
 */
export function shouldHidePatientPaymentUi(
    billStatus: DocumentStatus,
    totalPendingPaymentPatient: number,
): boolean {
    return billStatus !== DocumentStatus.DRAFT && totalPendingPaymentPatient <= 0;
}
